import { render, staticRenderFns } from "./NewBannerAd.vue?vue&type=template&id=05b2db26&"
import script from "./NewBannerAd.vue?vue&type=script&lang=js&"
export * from "./NewBannerAd.vue?vue&type=script&lang=js&"
import style0 from "./NewBannerAd.vue?vue&type=style&index=0&id=05b2db26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports